import { useState } from 'react';
import { appel } from '../api';
import { Erreur } from './Etat';

interface Props {
  personneId: string;
  depuis: string | null;
  motif: string | null;
  onChange: () => void;
}

/**
 * « Ne plus contacter » porte sur la personne : elle ne remonte plus du
 * vivier, sur aucune annonce. La décision se lève d'un bouton.
 */
export function NePlusContacter({ personneId, depuis, motif, onChange }: Props) {
  const [ouvert, setOuvert] = useState(false);
  const [saisie, setSaisie] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  async function enregistrer(nePlusContacter: boolean): Promise<void> {
    setEnvoi(true);
    setErreur(null);
    try {
      await appel(`/personnes/${personneId}/ne-plus-contacter`, {
        method: 'PUT',
        body: JSON.stringify({ nePlusContacter, motif: nePlusContacter ? saisie : null }),
      });
      setOuvert(false);
      setSaisie('');
      onChange();
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'Enregistrement impossible');
    } finally {
      setEnvoi(false);
    }
  }

  if (depuis) {
    return (
      <div className="ne-plus-contacter">
        <p className="signal-alerte">
          Ne plus contacter depuis le {new Date(depuis).toLocaleDateString('fr-FR')}
          {motif && ` — ${motif}`}
        </p>
        <button type="button" className="lien" disabled={envoi} onClick={() => void enregistrer(false)}>
          Lever
        </button>
        {erreur && <Erreur message={erreur} />}
      </div>
    );
  }

  if (!ouvert) {
    return (
      <button type="button" className="bouton-second" onClick={() => setOuvert(true)}>
        Ne plus contacter
      </button>
    );
  }

  return (
    <div className="ne-plus-contacter">
      <input
        type="text"
        value={saisie}
        maxLength={500}
        placeholder="Motif (facultatif)"
        aria-label="Motif"
        onChange={(e) => setSaisie(e.target.value)}
      />
      <button type="button" className="bouton" disabled={envoi} onClick={() => void enregistrer(true)}>
        Confirmer
      </button>
      <button type="button" className="lien" onClick={() => setOuvert(false)}>
        Annuler
      </button>
      {erreur && <Erreur message={erreur} />}
    </div>
  );
}
